import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { IBasket } from "../Basket/IBasket";
import { GlobalBasket } from "../GlobalBasket";
import { EnumCouponType } from "../enums/EnumCouponType";
import { EnumIconNames } from "../enums/EnumIconNames";
import { JsonBasketStats } from "../json-data-types/JsonBasketStats";
import { JsonCoupon } from "../json-data-types/JsonCoupon";
import { ServerCoupons } from "../server-queries/ServerCoupons";
import css from './BasketStatsOnBottom.m.scss';
import { ButtonInline } from "./ButtonInline";
import { Price } from "./Price";
interface Attrs {
    basketStats: JsonBasketStats
}

export class BasketStatsCoupons extends DomeComponent<Attrs> {
    divByCouponCode: Record<string, HTMLDivElement> = {}


    render() {
        return <div></div>
    }

    protected afterRender(): void {
        this.scheduleUpdate()
    }

    protected renderOtherCoupon(coupon: JsonCoupon) {
        return <>
            <div class={css.label}>
                Скидка
                <strong>{coupon.code}</strong>
                <ButtonInline iconName={EnumIconNames.TrashEmpty} onClick={() => this.removeCouponAsync(coupon.code)} />
            </div>
            <div class={css.value}> <strong>
                {this.renderDicountAmount(coupon.code)}
            </strong></div>
        </>

    }

    protected renderAutoCoupon(coupon: JsonCoupon) {
        const discountAmount = this.attrs.basketStats.discountAmountByCouponCode[coupon.code]
        if (discountAmount <= 0) return <></>
        return <>
            <div class={css.label}>
                Скидка
                <strong>{coupon.code}</strong>
            </div>
            <div class={css.value}> <strong>
                {this.renderDicountAmount(coupon.code)}
            </strong></div>
        </>
    }

    protected renderPersonalCoupon(coupon: JsonCoupon) {
        return <>
            <div class={css.label}>
                Персональная скидка
            </div>
            <div class={css.value}> <strong>
                {this.renderDicountAmount(coupon.code)}
            </strong></div>
        </>
    }


    protected async removeCouponAsync(code: string) {
        const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
        await basket.removeCouponAsync(code)

    }
    protected renderDicountAmount(code: string) {
        const discountAmount = this.attrs.basketStats.discountAmountByCouponCode[code]
        const discountAmountDollar = this.attrs.basketStats.discountAmountByCouponCodeInDollar?.[code]
        return discountAmount && discountAmount > 0 ? <Price price={discountAmount} priceInDollar={discountAmountDollar} /> : '0'
    }



    async updateAsync() {

        const basket: IBasket = await GlobalBasket.getCurrentBasketAsync()
        const couponCodes = new Set<string>([
            ...basket.getListOfCouponCodes(),
            ...Object.keys(this.attrs.basketStats.discountAmountByCouponCode || {})
        ])
        console.log('BasketStatsCoupons.tsx coupons currently in basket/render list', {
            couponCodesInBasket: basket.getListOfCouponCodes(),
            couponCodesWithDiscountStats: Object.keys(this.attrs.basketStats.discountAmountByCouponCode || {}),
            couponCodesToRender: Array.from(couponCodes),
        })
        const rows:Element[] = []
        for (const code of couponCodes) {
            try {
                const coupon = await ServerCoupons.getAsync(code)
                if (coupon.type === EnumCouponType.OnlyForUsers) {
                    rows.push(this.renderPersonalCoupon(coupon))

                } else if (coupon.autoApply) {
                    rows.push(this.renderAutoCoupon(coupon))
                } else {
                    rows.push(this.renderOtherCoupon(coupon))
                }
            } catch(error){
                console.warn('unable to get coupon', code, error)
            }

        }
        await DomeManipulator.replaceAsync(this.rootElement, <>{rows}</>)
    }
}
